import Chip from "@mui/material/Chip"
import PropTypes from "prop-types"

import { statusMeta } from "./meetingUtils"

export default function MeetingStatusChip({ status }) {
  const { label, chip } = statusMeta(status)
  return (
    <Chip
      size="small"
      label={label}
      data-testid="meeting-status-chip"
      variant="outlined"
      sx={{
        backgroundColor: chip.background,
        color: chip.text,
        borderColor: chip.border,
        fontWeight: 600,
      }}
    />
  )
}

MeetingStatusChip.propTypes = {
  status: PropTypes.string,
}
